import {defineNuxtRouteMiddleware} from '#app';
import {pageNames} from '~/lib/pageHelper';
import {useCompaniesStore} from '~/store/company/companies';
import {isValidCompanyId} from '~/lib/validators/companyId';

export default defineNuxtRouteMiddleware(async (to) => {
	const companiesStore = useCompaniesStore();

	if (to.params.companyId && to.name !== pageNames.companyDetailEdit) {
		const companyId = Number(to.params.companyId);
		
		if (isValidCompanyId(companyId) && companiesStore.companies.length === 0) {
			await companiesStore.fetchCompanies();
		}
	}
});
